import { useTranslation } from "react-i18next";
import colorsStore from "shared/store/colorsStore";
import { useJwtAuth } from "shared/hooks/useJwtAuth";
import { Alert, AlertDescription, AlertTitle } from "shared/components/ui/alert";
import { InfoIcon } from "lucide-react";

export const JwtRequiredPage: React.FC = () => {
    const colorsConfig = colorsStore((state) => state.colorsConfigStore);
    const { t } = useTranslation();
    const { jwtToken, isVerified } = useJwtAuth();

    return (
        <div className="mx-4 grid h-full place-items-center">
            <div className="w-full max-w-md space-y-8 text-center">
                <div className="space-y-4 pb-4">
                    <h1 style={{ color: colorsConfig.main }}>
                        {t("jwt.authentication_required")}
                    </h1>
                    <h3 className="font-medium dark:text-gray-500">
                        {t("jwt.token_required")}
                    </h3>

                    {jwtToken && !isVerified && (
                        <Alert variant="destructive" className="mb-4 text-left">
                            <InfoIcon className="h-4 w-4" />
                            <AlertTitle>
                                {t("jwt.invalid_token")}
                            </AlertTitle>
                            <AlertDescription>
                                {t("jwt.token_not_valid")}
                            </AlertDescription>
                        </Alert>
                    )}
                </div>
            </div>
        </div>
    );
}; 